import { showSmsConsent } from '~/acquisition/utils/smsConsent';

const FR_ES_PHONE_LENGTH = 9;
const EU_UK_PHONE_LENGTH = 10;
const DE_PHONE_LENGTH = 10;
const AU_PHONE_LENGTH = 11;

/**
 * Validates a phone number based on the top-level domain (TLD) and
 * expected phone number lengths for different regions.
 *
 * Phone number validation rules:
 * - If `showSmsConsent(tld)` returns `true` (EU domains):
 *   - `.de` (Germany): length must be 10 (DE) or 11 (AU — special case)
 *   - `.fr`, `.es`: length must be 9
 *   - Other EU/UK domains: length must be 10
 * - For non-EU domains (when `showSmsConsent` is false):
 *   - Phone number must be 12 characters long
 *
 * @param {string} phone - The phone number to validate.
 * @param {Object} [opts={}] - Optional parameters for validation.
 * @param {string} [opts.tld] - The top-level domain (e.g., '.de', '.fr') used to determine region-specific validation.
 * @returns {boolean} Returns `true` if the phone number is valid for the given region; otherwise, returns `false`.
 */
export const phoneValidate = (phone, opts = {}) => {
  if (!phone) {
    return false;
  }

  // showSmsConsent should only be true for EU domains
  if (showSmsConsent(opts.tld)) {
    if (opts.tld === '.de') {
      if (
        phone.length !== DE_PHONE_LENGTH &&
        phone.length !== AU_PHONE_LENGTH
      ) {
        return false;
      }
    } else if (['.fr', '.es'].includes(opts.tld)) {
      if (phone.length !== FR_ES_PHONE_LENGTH) {
        return false;
      }
    } else {
      if (phone.length !== EU_UK_PHONE_LENGTH) {
        return false;
      }
    }
    // dashes are part of values.phone
  } else if (phone.length !== 12) {
    return false;
  }

  return true;
};
